import React from 'react';
import usePopup from 'src/logic/hooks/use-popup';
import ContactUsPopup from '../contact/ContactUsPopup';
import LandingFooter from './footer/LandingFooter';
import LandingNavbar from './navbar/LandingNavbar';

type LandingLayoutProps = {
  children: React.ReactNode;
};

const LandingLayout = ({ children }: LandingLayoutProps) => {
  const contactUsPopup = usePopup();

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '100vh',
        }}
      >
        <LandingNavbar contactUsPopup={contactUsPopup} />
        <div style={{ flexGrow: 1, width: '100%' }}>{children}</div>
        <LandingFooter contactUsPopup={contactUsPopup} />
      </div>
      <ContactUsPopup popup={contactUsPopup} />
    </>
  );
};

export default LandingLayout;
